/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { ISnackbarAlert } from "../../shared/SnackbarAlert/SnackbarAlert";
import { SNACKBAR_MESSAGE, HIDE_MESSAGE } from "./types";
import { SNACKBAR_ALERT_DEFAULT_PROPS, NOT_SHOW_SNACKBAR } from "./constants";

export const setSnackBarMessage = (snackBarSuccess?: ISnackbarAlert) => {
	return {
		type: SNACKBAR_MESSAGE,
		snackBarSuccess
	};
};

export const displaySnackbar = (message: string, severity: 'success' | 'error' | 'warning') => {
	return setSnackBarMessage({
		...SNACKBAR_ALERT_DEFAULT_PROPS,
		message,
		severity
	});
};

export const hideSnackbar = () => {
	return {
		type: HIDE_MESSAGE,
		...NOT_SHOW_SNACKBAR
	};
};